/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts, globalThemeConstants, logoContainer } from '../../../theme';
import { GlobalContainer } from '../../common';

const HeaderContainerStyled = styled.div.attrs({
    className: 'header-container',
})`
    z-index: 5;
    max-width: 100%;
    min-width: ${globalThemeConstants.minSiteWidth};
    background-color: ${colors.backgroundColorWhite};
`;

export const HeaderContainerTopStyled = styled(HeaderContainerStyled)`
    z-index: 6;
`;

export const HeaderContainerBottomStyled = styled(HeaderContainerStyled)`
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
`;

const MainHeaderContainerStyled = styled(GlobalContainer)`
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    height: 64px;
    padding: 0 40px;
`;

const LogoContainerStyled = styled.div`
    padding-right: 15px;
    a {
        display: flex;
        flex-direction: column;
        text-decoration: none;
    }
`;

const LogoImgStyled = styled.div`
    ${logoContainer.LogoImgContainer}
    img {
        display: block;
    }
`;

const LogoLabelStyled = styled.span`
    opacity: 0.6;
    line-height: 1.33;
    letter-spacing: 0.3px;
    color: ${colors.headerLogoLabelColor};
    text-align: right;
    ${fonts.textSmall};
`;

const InfoBlockStyled = styled.div`
    flex-basis: auto;
    display: flex;
    align-content: stretch;
    align-items: center;
`;

const SupportBlockStyled = styled.div.attrs({
    className: 'support-block',
})`
    margin: 0 0 0 16px;
    display: flex;
    align-items: center;
    align-self: center;

    .support-block__item {
        display: flex;
        align-items: center;

        &:not(:last-child) {
            margin-right: 16px;
        }
    }

    .support-block__item-label {
        ${fonts.textMainBold};
        color: ${colors.textColorOpacity};
        margin-right: 8px;
    }
`;

const SupportImageStyled = styled.img`
    display: block;
    width: 32px;
    cursor: pointer;
`;

const PageInfoStyled = styled.img`
    display: block;
    width: 32px;
    opacity: 0.5;
    &.has-info {
        cursor: pointer;
        opacity: 1;
    }
`;

const InfoLinkStyled = styled.span`
    display: block;
    cursor: pointer;
    color: ${colors.headerLinkColor};
    opacity: ${colors.headerLinkOpacity};
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.3px;
    &:hover {
        text-decoration: underline;
    }
`;

const HelpTipsContainerStyled = styled.div.attrs({
    className: 'help-tips-container',
})`
    margin: 0 auto;
    width: 100%; // ie11
    min-width: ${globalThemeConstants.minSiteWidth};
    max-width: ${globalThemeConstants.maxSiteWidth};
    box-sizing: border-box;
`;

const HelpTipsBlockStyled = styled.div.attrs({
    className: 'help-tips-block',
})`
    position: relative;
    background: ${colors.headerHelpTipsContainerColor};
    padding: 12px 40px;
`;

const TipsTextStyled = styled.div`
    flex-grow: 1;
    margin: 0 40px 0 18px;
`;

const TipsClosedStyled = styled.div.attrs({
    className: 'tips-item__close',
})`
    position: absolute;
    top: 12px;
    right: 48px;
    cursor: pointer;
`;

export {
    HelpTipsContainerStyled,
    HelpTipsBlockStyled,
    HeaderContainerStyled,
    InfoBlockStyled,
    InfoLinkStyled,
    LogoContainerStyled,
    LogoImgStyled,
    LogoLabelStyled,
    MainHeaderContainerStyled,
    PageInfoStyled,
    SupportBlockStyled,
    SupportImageStyled,
    TipsTextStyled,
    TipsClosedStyled,
};
